import identity from 'lodash/identity'
import isNil from 'lodash/isNil'
import React from 'react'
import { Field as ReduxFormField } from 'redux-form'
import styled from 'styled-components'
import { typeHelper } from 'utils'

const RadioLabel = styled.label`
  font-size: 1.5rem;
  font-weight: 600;
`

const RadioText = styled.span`
  margin-left: 0.75rem;
  font-size: 0.875rem;
`

const Field = (props) => {
  const isRadio = props.type === 'radio' && !isNil(props.label)

  return (
    <>
      {isRadio ? (
        <RadioLabel>
          <ReduxFormField {...props} />
          <RadioText>{String(props.label)}</RadioText>
        </RadioLabel>
      ) : (
        <ReduxFormField
          parse={props.type === 'number' ? typeHelper.toNumber : identity}
          {...props}
        />
      )}
    </>
  )
}

export default Field
